import {filterUnique, findEmailsOrUrls, findPhones} from './utils';
import {RawMessage} from '../IRawMessagesStore';

export function textEntitiesBuilder(rawMessage: RawMessage): RawMessage {
  const text = rawMessage.text;
  const textEntities = rawMessage.textEntities || [];

  const emailAndUrlEntities = filterUnique(findEmailsOrUrls(text), textEntities, true);
  const phoneEntities = filterUnique(findPhones(text), textEntities);

  if (emailAndUrlEntities.length || phoneEntities.length) {
    rawMessage.textEntities = [...textEntities, ...emailAndUrlEntities, ...phoneEntities];
  }

  return rawMessage;
}

export default textEntitiesBuilder;
